import './GlitchText.css';

/* ============================================================================
   GlitchText — chromatic aberration + occasional tracking tear.

   Two pseudo-element copies of the string sit behind the real one in cyan and
   red, permanently offset by a sub-pixel amount (the RGB bleed) and violently
   displaced on an irregular cycle (the tear). Both offsets scale with
   --fx-aberration, so turning effects down collapses them to nothing.

   `as` lets a heading stay a heading — this is styling, not markup.
   ========================================================================== */

function GlitchText({
  children,
  as: Tag = 'span',
  intensity = 'normal', // subtle | normal | extreme
  tone = 'paper', // paper | red | cyan | gold
  className = '',
  ...rest
}) {
  const text = typeof children === 'string' ? children : undefined;

  return (
    <Tag
      className={`ui-glitch ui-glitch--${intensity} ui-glitch--${tone} ${className}`}
      data-text={text}
      {...rest}
    >
      {/* data-text is repeated here: attr() only reads the attribute off the
          element the pseudo-element belongs to, and the tear slice in the
          `extreme` variant hangs off this span rather than the wrapper. */}
      <span className="ui-glitch__real" data-text={text}>
        {children}
      </span>
    </Tag>
  );
}

export default GlitchText;
